import React, { useState } from 'react';
import { Palette, ChevronDown, ChevronUp, Check } from 'lucide-react';
import { useTheme, themes } from '../context/ThemeContext';

export default function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleThemeChange = (newTheme: string) => {
    setTheme(newTheme as any);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={toggleDropdown}
        className={`flex items-center gap-1 text-xs ${themes[theme].textSecondary} hover:${themes[theme].text} transition-colors`}
        aria-label="Change theme"
      >
        <Palette className="h-3 w-3" />
        <span className="hidden sm:inline">Theme</span>
        {isOpen ? (
          <ChevronUp className="h-3 w-3" />
        ) : (
          <ChevronDown className="h-3 w-3" />
        )}
      </button>

      {isOpen && (
        <div 
          className={`absolute right-0 mt-2 w-48 rounded-md shadow-lg ${themes[theme].dropdown} ring-1 ring-black ring-opacity-5 z-50`}
        >
          <div className="py-1" role="menu" aria-orientation="vertical">
            {Object.entries(themes).map(([themeKey, themeValue]) => (
              <button
                key={themeKey}
                onClick={() => handleThemeChange(themeKey)}
                className={`w-full text-left px-4 py-2 text-sm ${themes[theme].text} hover:${themes[theme].secondary} flex items-center justify-between`}
                role="menuitem"
              >
                <span>{themeValue.name}</span>
                {theme === themeKey && <Check className="h-4 w-4" />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}